var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultPicGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.049 190C146.983 190 190 146.983 190 94.951C190 43.017 146.885 0 94.951 0C43.017 0 0 43.017 0 94.951C0 146.983 43.115 190 95.049 190ZM95.049 126.699C67.7102 126.699 46.6426 136.498 37.1377 147.473C24.5952 133.657 17.05 115.235 17.05 94.951C17.05 51.64 51.64 16.854 94.951 16.854C138.262 16.854 173.048 51.64 173.146 94.951C173.146 115.235 165.503 133.657 152.96 147.571C143.455 136.498 122.388 126.699 95.049 126.699ZM95.049 111.119C112.883 111.315 126.895 96.0289 126.895 76.1372C126.895 57.4213 112.785 41.8412 95.049 41.8412C77.2151 41.8412 63.1047 57.4213 63.2027 76.1372C63.3007 96.0289 77.1171 111.021 95.049 111.119Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPicGray);
export default __webpack_public_path__ + "static/media/default-pic-gray.e13b4f7d56d4b7821e01f08c1499ef93.svg";
export { ForwardRef as ReactComponent };